$(function () {
    $.fn.isInViewport = function () {
        var elementTop = $(this).offset().top;
        var elementBottom = elementTop + $(this).outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };

    /**
     * Updates the browser's URL without reloading the page, optionally including query parameters.
     *
     * @param {object} params - An object containing key-value pairs representing query parameters.
     */
    window.updateURL = function (params) {

        // Remove keys with empty or undefined values
        for (const key in params) {
            if (params[key] === 0 || params[key] === "" || params[key] === undefined || (Array.isArray(params[key]) && params[key].length === 0)) {
                delete params[key];
            }
        }

        // Check if there are any params to include in the URL
        if (Object.keys(params).length > 0) {
            // Build the URL with the params parameters.
            const url = `?${new URLSearchParams(params).toString()}`;
            // Update the browser's URL without reloading.
            window.history.pushState({path: url}, '', url);
        } else {
            // No params, set the URL to the current URL without query parameters.
            const currentURL = window.location.href.split('?')[0];
            window.history.pushState({path: currentURL}, '', currentURL);
        }
    };

    // Selecting the password input field, password icon, and show/hide button
    let showHideButton = $('.form-control-showhide');

    // Adding a click event handler to the show/hide button
    showHideButton.click(function () {
        let passwordInput = $($(this).data('target'));
        let passwordIcon = $(this).closest('.form-group').find('.form-control-icon use[href="#form-lock"]');

        // Check if the password input field is currently of type 'password'
        if (passwordInput.attr('type') === 'password') {
            passwordInput.attr('type', 'text');
            passwordIcon.attr('href', '#form-unlock');
            $(this).addClass('active'); // Add the 'active' class to the clicked button
        } else {
            passwordInput.attr('type', 'password');
            passwordIcon.attr('href', '#form-lock');
            $(this).removeClass('active'); // Remove the 'active' class from the clicked button
        }
    });
});